import { Box, ThemeProvider, Typography, useTheme } from "@mui/material";

const BalingSection: React.FC = () => {
  const theme = useTheme();
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "left",
          background: theme.palette.background.default,
        }}
      >
        <Typography
          variant="h4"
          color="primary"
          sx={{
            padding: 1,
            borderBottom: 4,
            borderWidth: "40%",
            marginLeft: 2,
          }}
        >
          Agricultural Background
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "grid",
          justifyContent: "",
          alignItems: "left",

          background: theme.palette.background.default,
        }}
      >
        <Typography
          variant="body1"
          color="primary"
          sx={{
            margin: 2,
          }}
        >
             I grew up on a family-operated beef and grain farm in Pecatonica,
          Illinois with my older brother Danny and two younger sisters, Holly
          and Emma. From an early age we were active in the Seward Determination
          4-H Club, showing beef cattle and various general projects every
          August at the Winnebago County Fair. During my freshman year of high
          school, my brother and I founded Daly Custom Baling, taking out a loan
          on a John Deere mower conditioner, a Kuhn Knight hay
          rake, and a John Deere round baler. Through hard work we made each
          year&apos;s payment, and I saved the rest away for college. I served
          as the &quot;CFO&quot; for the business, managing records & finances,
          and also was responsible for day-to-day operations like fieldwork and
          equipment repair.
        </Typography>
      </Box>
    </ThemeProvider>
  );
};
export default BalingSection;
